export default __webpack_public_path__ + "static/media/step 2.bd066e68.png";